<template>
	<div class="hello">
		<!-- 公共头 start -->
		<Header></Header>
		<!-- 公共头 end -->

		<div class="container">
			<div class="column1 mt30 bg-white flex">
				<!-- 焦点图 start -->
				<div class="slide m-100">
					<div class="swiper-container" style="cursor: -webkit-grab">
						<ul class="swiper-wrapper">
							<li v-for="(item, index) in carouselList" :key="index" class="swiper-slide" style="width: 566px">
								<a href="" target="_blank" class="pich" :title="item.intro">
									<img :src="utils.imgUrl + item.imgUrl" class="img" />
									<span>{{ item.intro }}</span>
								</a>
							</li>
						</ul>
					</div>
					<a class="arrow-left" href="javascript:void(0)"></a>
					<a class="arrow-right" href="javascript:void(0)"></a>
					<div class="pagination"></div>
				</div>
				<!-- 焦点图 end -->

				<!-- 最新要闻等 start -->
				<div class="focus tab m-mt20 m-100 m-hauto">
					<div class="hd htitle">
						<a @mouseover="(tabHover = 1), getNewsListH()" :class="tabHover == 1 ? 'on' : ''" target="_blank">{{ menuList[2].name }}</a>
						<i>|</i>
						<a @mouseover="(tabHover = 2), getNewsListH()" :class="tabHover == 2 ? 'on' : ''" target="_blank">{{ menuList[1].name }}</a>
					</div>
					<div class="bd">
						<div v-if="tabHover == 1" :class="tabHover == 1 ? 'c on' : ''">
							<ul class="newslist MD dot mt10">
								<li v-for="(item, index) in hNewsList1" :key="index">
									<a target="_blank" :title="item.title" @click="toPage('/news_info?id=' + item.id)">{{ item.title }}</a>
									<span class="date">{{ item.publishTime }}</span>
								</li>
							</ul>
							<a target="_blank" class="column-more">更多+</a>
						</div>
						<div v-if="tabHover == 2" :class="tabHover == 2 ? 'c on' : ''">
							<ul class="newslist MD dot mt10">
								<li v-for="(item, index) in hNewsList2" :key="index">
									<a target="_blank" :title="item.title" @click="toPage('/news_info?id=' + item.id)">{{ item.title }}</a>
									<span class="date">{{ item.publishTime }}</span>
								</li>
							</ul>
							<a target="_blank" class="column-more">更多+</a>
						</div>
					</div>
				</div>
				<!-- 最新要闻等 end -->
			</div>

			<div class="scroll_box">
				<div class="warp_box">
					<div class="title">学会颁发证书</div>
					<vue-seamless-scroll v-if="certList.length != 0" :data="certList" :key="timeKey3" :class-option="classOption2" class="warp3">
						<ul class="ul-item">
							<li class="li-item" v-for="(item, index) in certList" :key="index">
								<img :src="utils.imgUrl + item.photo" alt="" />
								<a>{{ item.name }}</a>
							</li>
						</ul>
					</vue-seamless-scroll>
				</div>

				<div class="warp_box">
					<div class="title">授牌单位</div>
					<vue-seamless-scroll :data="unitList" :key="timeKey" :limitMoveNum="10" class="warp">
						<div class="box">
							<div class="items" v-for="(item, index) in unitList" :key="index">
								<div class="left">
									<img :src="utils.imgUrl + item.logo" alt="" />
								</div>
								<div class="right">
									<div class="">{{ item.name }}</div>
									<div class="">{{ '地址:' + item.address }}</div>
									<div class="">{{ '电话:' + item.phone }}</div>
								</div>
							</div>
						</div>
					</vue-seamless-scroll>
				</div>
			</div>

			<!-- 专题 start -->
			<div class="ztzl mt20">
				<div class="zt">
					<div class="swiper-container2" style="cursor: -webkit-grab">
						<div class="swiper-wrapper">
							<div v-for="(item2, index2) in adList" :key="index2" class="swiper-slide" style="width: 406.667px; height: 83px">
								<a :href="item2.adLink" class="pich" title="" target="_blank">
									<img class="img" :src="utils.imgUrl + item2.adImg" :alt="item2.adName" />
								</a>
							</div>
						</div>
					</div>
					<a class="arrow-left2"></a>
					<a class="arrow-right2"></a>
				</div>
			</div>
			<!-- 专题 end -->

			<div class="column2 mt20">
				<div class="hd bg-white ctitle">
					<a v-for="(item, index) in menuList" :key="index" @mouseover="(bottomHover = index), getNewsList(item.id)" :class="bottomHover == index ? 'on' : ''">{{ item.name }}</a>
				</div>
				<div class="bd bg-white">
					<div class="c rcyj on">
						<div class="hd htitle">
							<a target="_blank" class="on">{{ menuList[bottomHover].name }}</a>
							<a @click="toPage('/news_list?category=' + menuList[bottomHover].id)" target="_blank" class="hmore cp">更多+</a>
						</div>
						<ul class="newslist MD dot mt10 large">
							<li v-for="(item, index) in newsList" :key="index">
								<a class="title cp" @click="toPage('/news_info?id=' + item.id)">{{ item.title }}</a>
								<span class="date">{{ item.publishTime }}</span>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<!-- <div class="warp_box">
				<div class="title">
					专家推荐
				</div>
				<vue-seamless-scroll v-if="expertList.length != 0" :data="expertList" :key="timeKey2" :class-option="classOption" class="warp2">
					<ul class="ul-item">
						<li class="li-item" v-for="(item, index) in expertList" :key="index">
							<img :src="utils.imgUrl + item.photo" alt="" />
							<a>{{ item.name }}</a>
						</li>
					</ul>
				</vue-seamless-scroll>
			</div> -->
		</div>

		<!-- 公共尾 start -->
		<Footer></Footer>
		<!-- 公共尾 end -->
	</div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll';
import 'swiper/css/swiper.css';
import Swiper from 'swiper';
import Header from '@/components/header';
import Footer from '@/components/footer';
export default {
	components: {
		Header,
		Footer,
		vueSeamlessScroll
	},
	name: 'Index',
	data() {
		return {
			timeKey: '',
			timeKey2: '',
			timeKey3: '',
			bottomHover: 0,
			tabHover: 1,
			slidesPerView: 3,
			carouselList: [],
			adList: [],
			menuList: [],
			newsList: [],
			hNewsList1: [],
			hNewsList2: [],
			unitList: [],
			expertList: [],
			classOption: {
				limitMoveNum: 2,
				direction: 2
			},
			certList: [],
			classOption2: {
				limitMoveNum: 2,
				direction: 2
			}
		};
	},
	metaInfo() {
		return {
			title: this.$route.meta.title,
			meta: [
				{ name: 'keywords', content: this.$route.meta.keywords },
				{ name: 'description', content: this.$route.meta.description }
			]
		};
	},
	mounted() {
		var that = this;
		window.addEventListener('resize', function() {
			that.toPage('/');
			that.getCarouselList();
			that.getAdList();
			that.getMenuList();
		});
		this.timeKey = new Date().getTime();
		this.timeKey2 = new Date().getTime() + 1;
		this.timeKey3 = new Date().getTime() + 2;
		this.getCarouselList();
		this.getAdList();
		this.getMenuList();
		this.getUnitList();
		this.getExpertList();
		this.getCertList();
	},
	methods: {
		// 获取证书列表
		getCertList() {
			this.req({
				url: '/system/expert/list',
				params: {
					pageNum: 1,
					pageSize: 20,
					type: '2'
				},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					for (let i in res.rows) {
						this.certList.push(res.rows[i]);
					}
					for (let i in res.rows) {
						this.certList.push(res.rows[i]);
					}
					for (let i in res.rows) {
						this.certList.push(res.rows[i]);
					}
				}
			});
		},
		// 获取专家列表
		getExpertList() {
			this.req({
				url: '/system/expert/list',
				params: {
					pageNum: 1,
					pageSize: 20,
					type: '1'
				},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					for (let i in res.rows) {
						this.expertList.push(res.rows[i]);
					}
					for (let i in res.rows) {
						this.expertList.push(res.rows[i]);
					}
					for (let i in res.rows) {
						this.expertList.push(res.rows[i]);
					}
				}
			});
		},
		// 获取单位列表
		getUnitList() {
			this.req({
				url: '/system/unit/list',
				params: {
					pageNum: 1,
					pageSize: 20
				},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.unitList = res.rows;
				}
			});
		},
		// 获取新闻列表h
		getNewsListH() {
			this.req({
				url: '/system/news/list',
				params: {
					pageNum: 1,
					pageSize: 6,
					category: this.menuList[2].id
				},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.hNewsList1 = res.rows;
				}
			});
			this.req({
				url: '/system/news/list',
				params: {
					pageNum: 1,
					pageSize: 6,
					category: this.menuList[1].id
				},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.hNewsList2 = res.rows;
				}
			});
		},
		// 获取新闻列表
		getNewsList(val) {
			this.req({
				url: '/system/news/list',
				params: {
					pageNum: 1,
					pageSize: 8,
					category: val
				},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.newsList = res.rows;
					this.total = res.total;
				}
			});
		},
		// 获取菜单列表
		getMenuList() {
			this.req({
				url: '/system/menus/list',
				params: {},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.menuList = [];
					for (let i in res.rows) {
						if (i !=0 && i <7) {
							this.menuList.push(res.rows[i]);
						}
					}
					this.getNewsList(this.menuList[0].id);
					this.getNewsListH();
				}
			});
		},
		// 获取广告列表
		getAdList() {
			this.req({
				url: '/system/ads/list',
				params: {},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.adList = res.rows;
					this.$nextTick(function() {
						this.initSwiper2();
					});
				}
			});
		},
		// 获取轮播图列表
		getCarouselList() {
			this.req({
				url: '/system/carousel/list',
				params: {},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.carouselList = res.rows;
					this.$nextTick(function() {
						this.initSwiper1();
					});
				}
			});
		},
		// 初始化轮播图
		initSwiper1() {
			var winW = document.documentElement.clientWidth;
			this.slidesPerView = 3;
			if (winW <= 991 && winW > 500) {
				this.slidesPerView = 2;
			} else if (winW <= 500) {
				this.slidesPerView = 1;
			}
			this.swiper = new Swiper('.swiper-container', {
				pagination: {
					// 如果需要分页器
					el: '.pagination',
					clickable: true,
					bulletClass: 'my-bullet', //需设置.my-bullet样式
					bulletActiveClass: 'my-bullet-active'
				},
				observer: true,
				observeParents: true,
				navigation: {
					// 如果需要前进后退按钮
					nextEl: '.arrow-right',
					prevEl: '.arrow-left'
				},
				grabCursor: true, // 悬浮时鼠标样式切换
				autoplay: {
					delay: 4000 // 多少秒切换一次，默认3000ms
				},
				loop: true // 循环模式选项
			});
		},
		// 初始化轮播图
		initSwiper2() {
			var winW = document.documentElement.clientWidth;
			this.slidesPerView = 3;
			if (winW <= 991 && winW > 500) {
				this.slidesPerView = 2;
			} else if (winW <= 500) {
				this.slidesPerView = 1;
			}
			this.swiper2 = new Swiper('.swiper-container2', {
				pagination: {
					// 如果需要分页器
					el: '.pagination2',
					clickable: true,
					bulletClass: 'my-bullet', //需设置.my-bullet样式
					bulletActiveClass: 'my-bullet-active'
				},
				slidesPerView: this.slidesPerView,
				observer: true,
				observeParents: true,
				navigation: {
					// 如果需要前进后退按钮
					nextEl: '.arrow-right2',
					prevEl: '.arrow-left2'
				},
				grabCursor: true, // 悬浮时鼠标样式切换
				autoplay: {
					delay: 4000 // 多少秒切换一次，默认3000ms
				},
				loop: true // 循环模式选项
			});
		},
		toPage(path) {
			this.$router.push(path);
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../assets/index/idangerous.swiper.css"></style>
<style scoped src="../assets/index/common.css"></style>
<style scoped src="../assets/index/index.css"></style>
<style lang="scss" scoped>
.logo_bg {
	width: 778px;
	height: 100px;
}
.scroll_box {
	display: flex;
	justify-content: space-between;
}
.warp {
	width: 400px;
	height: 220px;
	margin: 10px 0;
	overflow: hidden;
	box-sizing: border-box;
	.box {
		.items {
			height: 100px;
			display: flex;
			font-size: 15px;
			// border: 1px solid #000000;
			// margin: 10px 0;
			padding: 10px;
			box-sizing: border-box;
			.left {
				width: 90px;
				height: 90px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				img {
					max-width: 90px;
					height: auto;
				}
			}
			.right {
				margin: 0 0 0 10px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				div {
					cursor: pointer;
				}
			}
		}
	}
}
.warp2 {
	width: 1160px;
	// height: 120px;
	margin: 0 auto;
	padding: 20px;
	overflow: hidden;
	ul {
		list-style: none;
		padding: 0;
		margin: 0 auto;
		&.ul-item {
			display: flex;
			.li-item {
				width: 122px;
				margin-right: 10px;
				text-align: center;
				img {
					width: 122px;
					height: 162px;
					cursor: pointer;
					border: 1px solid #eeeeee;
					padding: 2px;
				}
				a {
					text-decoration: underline;
					cursor: pointer;
				}
			}
		}
	}
}
.warp3 {
	width: 780px;
	height: 220px;
	margin: 10px 0;
	overflow: hidden;
	box-sizing: border-box;
	ul {
		list-style: none;
		padding: 0;
		margin: 0 auto;
		&.ul-item {
			display: flex;
			.li-item {
				width: 265px;
				height: 220px;
				margin-right: 10px;
				text-align: center;
				display: flex;
				flex-direction: column;
				justify-content: center;
				img {
					width: 265px;
					height: 180px;
					cursor: pointer;
					border: 1px solid #eeeeee;
					padding: 2px;
				}
				a {
					text-decoration: underline;
					cursor: pointer;
				}
			}
		}
	}
}
.warp_box {
	margin: 20px 0 0 0;
	background: #ffffff;
	.title {
		font-size: 20px;
		font-weight: 700;
		border-bottom: 2px solid #368ec9;
		padding: 15px 20px;
		border-bottom: 1px solid #dcdcdc;
		position: relative;
		&::after {
			position: absolute;
			bottom: -1px;
			left: 20px;
			content: '';
			width: 80px;
			height: 2px;
			background: #368ec9;
		}
	}
}
</style>
<style lang="scss">
.my-bullet {
	// background: red !important;
	display: inline-block;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #fff;
	margin: 0 5px;
	cursor: pointer;
	opacity: 0.5;
}

.my-bullet-active {
	background: #ffffff !important;
	opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue